import HaveInquiry from './HaveInquiry'

export default HaveInquiry
